export const TID = {
  // connect
  tokenInput: "token-input",
  connectBtn: "connect-btn",
  csvInput: "csv-input",
  // header
  syncBtn: "sync-btn",
  disconnectBtn: "disconnect-btn",
  connectionStatus: "connection-status",
  themeToggle: "theme-toggle",
  exportPdfBtn: "export-pdf-btn",
  printBtn: "print-btn",
  // dashboard
  kpiOpenPipeline: "kpi-open-pipeline",
  kpiWeightedForecast: "kpi-weighted-forecast",
  kpiWonValue: "kpi-won-value",
  kpiWinRate: "kpi-win-rate",
  // report
  generateReportBtn: "generate-report-btn",
  reportContent: "report-content",
  editReportBtn: "edit-report-btn",
  reportEditor: "report-editor",
  saveReportBtn: "save-report-btn",
  cancelEditBtn: "cancel-edit-btn",
  clearReportBtn: "clear-report-btn",
  // chat
  chatInput: "chat-input",
  chatSendBtn: "chat-send-btn",
  chatMessages: "chat-messages",
  chatIncludeToggle: "chat-include-toggle",
  // nav
  tabConnect: "tab-connect",
  tabChat: "tab-chat",
  tabAnalyst: "tab-analyst",
  tabConnections: "tab-connections",
  navAnalyticsMenu: "nav-analytics-menu",
  // landing
  landingRoot: "landing-root",
  landingCtaPrimary: "landing-cta-primary",
  landingCtaHeader: "landing-cta-header",
  landingCtaFinal: "landing-cta-final",
  landingThemeToggle: "landing-theme-toggle",
  // connections
  contactsCountInput: "contacts-count-input",
  syncContactsBtn: "sync-contacts-btn",
  contactsFilter: "contacts-filter",
  contactsGrid: "contacts-grid",
  connectionsMap: "connections-map",
  connectionsReportContent: "connections-report-content",
  genConnectionsReportBtn: "gen-connections-report-btn",
  connCsvBtn: "conn-csv-btn",
  connClearBtn: "conn-clear-btn",
  // team
  teamScorecard: "team-scorecard",
  teamRepRow: "team-rep-row",
  teamReportContent: "team-report-content",
  genTeamReportBtn: "gen-team-report-btn",
  // activity insights
  activityGranularity: "activity-granularity",
  activityTrendChart: "activity-trend-chart",
  activityReportContent: "activity-report-content",
  genActivityReportBtn: "gen-activity-report-btn",
  // forecast
  forecastQuotaInput: "forecast-quota-input",
  forecastRangeSelect: "forecast-range-select",
  forecastReportContent: "forecast-report-content",
  genForecastReportBtn: "gen-forecast-report-btn",
  // funnel
  funnelPipelineSelect: "funnel-pipeline-select",
  funnelReportContent: "funnel-report-content",
  genFunnelReportBtn: "gen-funnel-report-btn",
  // deals
  dealsTable: "deals-table",
  dealsSearchInput: "deals-search-input",
  dealsStatusFilter: "deals-status-filter",
  dealsReportContent: "deals-report-content",
  genDealsReportBtn: "gen-deals-report-btn",
  // data health
  dataHealthScore: "data-health-score",
  dataHealthReportContent: "data-health-report-content",
  genDataHealthReportBtn: "gen-data-health-report-btn",
};
